import userConstants from '../constants';

const initialState = {
  isFetching: false,
  error: null,
  updateSource: null,
};

// eslint-disable-next-line default-param-last
export function userUpdate(state = initialState, action) {
  const { type, payload, meta: { source: updateSource = null } = {} } = action;
  switch (type) {
    case userConstants.UPDATE_USER_REQUEST:
      return {
        isFetching: true,
        error: null,
        updateSource,
      };
    case userConstants.UPDATE_USER_SUCCESS:
      return {
        isFetching: false,
        error: null,
        updateSource,
      };
    case userConstants.UPDATE_USER_FAILURE:
      return {
        isFetching: false,
        error: payload,
        updateSource,
      };
    case userConstants.LOGOUT:
      return initialState;
    default:
      return state;
  }
}
